import { useState } from "react";
import Button from "../Misc/Button";
import { AccountViews, Customer, Subscription } from "../Types";
import CustomerView from "./CustomerView";
import "./index.css";
import SettingsView from "./SettingsView";
import SubscriptionView from "./SubscriptionView";

type Props = {
  customer: Customer,
  subscriptions: Subscription[]
}

export default function Account({customer, subscriptions}:Props) {
const [currentView, setCurrentView] = useState<AccountViews>(AccountViews.customer)
  return (
    <div className="account-container">
      <div className="account-button-container">
      <Button label="Kundinformation" isActive={currentView === AccountViews.customer} isPrimary={true} onClick={()=>setCurrentView(AccountViews.customer)}/> 
      <Button label="Abonnemang" isActive={currentView === AccountViews.subscriptions} isPrimary={true} onClick={()=>setCurrentView(AccountViews.subscriptions)}/> 
      <Button label="Inställningar" isActive={currentView === AccountViews.settings} isPrimary={true} onClick={()=>setCurrentView(AccountViews.settings)}/> 
      </div>
      {currentView === AccountViews.customer ? <CustomerView customer={customer} /> : currentView === AccountViews.subscriptions ? <SubscriptionView subscriptions={subscriptions} /> : <SettingsView subscriptions={subscriptions} />}
    </div>
  );
}
